import ApexCharts from "apexcharts"
import React, { useEffect, useRef, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import DateRangePicker from "react-bootstrap-daterangepicker"
import "bootstrap-daterangepicker/daterangepicker.css"
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger } from "react-bootstrap";
import { AreaChart, LineChart, Area, LabelList, BarChart, Bar, Tooltip, Brush, Line, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, PieChart, Pie, Cell, } from 'recharts';
import { getDashboardGraphDropdown, getDashboardSecondGraphDropdown, getPricingDashboardAllLeadsGraph, getPricingDashboardCounter } from "../../Redux/action/Admin/CustomerAction"
// import { LineChart } from '@mui/x-charts/LineChart';
const PricingDashboard = () => {
    // Deals By Stage
    const [years, setYears] = useState([]);
    const [pricingcurrentYear, setpricingCurrentYear] = useState(localStorage.getItem('pricingcurrentYear') || new Date().getFullYear());
    const [graphDropdownData, setGraphDropdownData] = useState([]);
    const [selectedGraphData, setSelectedGraphData] = useState([]);
    const [pricingdropdownValue, setDropdownValue] = useState(localStorage.getItem('pricingdropdownValue') || 'Last Week');
    const [secondpricingdropdownValue, setsecondpricingDropdownValue] = useState(localStorage.getItem('secondpricingdropdownValue') || 'Last Week');
    const [selectedsecondGraphData, setsecondSelectedGraphData] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        const pricingcurrentYear = new Date().getFullYear();
        const lastFiveYears = Array.from({ length: 5 }, (_, i) => pricingcurrentYear - i);
        setYears(lastFiveYears);
    }, []);

    useEffect(() => {
        // Fetch data whenever pricingcurrentYear changes
        dispatch(getPricingDashboardCounter(pricingcurrentYear));
        dispatch(getPricingDashboardAllLeadsGraph(pricingcurrentYear));
        dispatch(getDashboardGraphDropdown(pricingcurrentYear));
        dispatch(getDashboardSecondGraphDropdown(pricingcurrentYear));
    }, [pricingcurrentYear]);

    const {
        loadingPricingDashboardCounterApi,
        PricingDashboardCounterError,
        PricingDashboardCounter,

        loadingPricingDashboardAllLeadsGraphApi,
        PricingDashboardAllLeadsGraphError,
        PricingDashboardAllLeadsGraph,

        DashboardGraphDropdownData,
        DashboardSecondGraphDropdownData
    } = useSelector((state) => state?.CustomerReducer);


    // Handle year change
    const handleYearChange = (e) => {
        const year = e.target.value;
        setpricingCurrentYear(year);
        localStorage.setItem('pricingcurrentYear', year);
        dispatch(getDashboardGraphDropdown(year));
        dispatch(getDashboardSecondGraphDropdown(pricingcurrentYear));
        if (year == new Date().getFullYear()) {
            setDropdownValue('Last Week');
            setsecondpricingDropdownValue('Last Week');
            setSelectedGraphData(PricingDashboardAllLeadsGraph.leads.monthly);
        }
        else {
            setDropdownValue('Monthly');
            setsecondpricingDropdownValue('Monthly');
            setSelectedGraphData([PricingDashboardAllLeadsGraph.leads.lastWeek]);
        }

    };


    const handleGraphDropdownChange = (e) => {
        const value = e.target.value;
        setDropdownValue(value);
        localStorage.setItem('pricingdropdownValue', value);

        if (PricingDashboardAllLeadsGraph?.leads) {
            let data;
            switch (value) {
                // case 'Today':
                //     data = [PricingDashboardAllLeadsGraph.leads.today];
                //     break;
                case 'Last Week':
                    data = PricingDashboardAllLeadsGraph.leads.lastWeek;
                    break;
                case 'Monthly':
                    data = PricingDashboardAllLeadsGraph.leads.monthly;
                    break;
                case 'Half Yearly':
                    data = PricingDashboardAllLeadsGraph.leads.halfYearly;
                    break;
                case 'Yearly':
                    data = PricingDashboardAllLeadsGraph.leads.yearly;
                    break;
                default:
                    data = [];
            }
            setSelectedGraphData(data);

        }
    };

    useEffect(() => {
        if (PricingDashboardAllLeadsGraph?.leads) {
            let data;
            switch (pricingdropdownValue) {
                // case 'Today':
                //     data = [PricingDashboardAllLeadsGraph.leads.today];
                //     break;
                case 'Last Week':
                    data = PricingDashboardAllLeadsGraph.leads.lastWeek;
                    break;
                case 'Monthly':
                    data = PricingDashboardAllLeadsGraph.leads.monthly;
                    break;
                case 'Half Yearly':
                    data = PricingDashboardAllLeadsGraph.leads.halfYearly;
                    break;
                case 'Yearly':
                    data = PricingDashboardAllLeadsGraph.leads.yearly;
                    break;
                default:
                    data = []
            }
            setSelectedGraphData(data);

        }
    }, [pricingdropdownValue, pricingcurrentYear, PricingDashboardAllLeadsGraph]);






    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <ul style={{ fontSize: '13px' }} className="d-flex justify-content-center gap-2 pb-2">
                {payload.map((entry, index) => {

                    let color;
                    if (entry.value === 'Converted') {
                        color = '#5cb85c';
                    } else if (entry.value === 'Picked') {
                        color = '#ffdc31';
                    } else if (entry.value === 'NotConverted') {
                        color = '#e41f07';
                    }

                    return (
                        <li key={`item-${index}`} style={{ color }}>
                            {entry.value}
                        </li>
                    );
                })}
            </ul>
        );
    };

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF', '#FF5A91', '#00FFAB', '#4F94D4', '#FF4500'];

    const chartRef = useRef(null)
    useEffect(() => {
        localStorage.setItem("menuOpened", "Dashboard")
    }, [])
    useEffect(() => {
        if (chartRef.current) {
            const options = {
                series: [
                    {
                        name: "pricing",
                        colors: ["#FFC38F"],
                        data: [
                            {
                                x: "Inpipeline",
                                y: 400
                            },
                            {
                                x: "Follow Up",
                                y: 130
                            },
                            {
                                x: "Schedule",
                                y: 248
                            },
                            {
                                x: "Conversation",
                                y: 470
                            },
                            {
                                x: "Won",
                                y: 470
                            },
                            {
                                x: "Lost",
                                y: 180
                            }
                        ]
                    }
                ],
                chart: {
                    type: "bar",
                    height: 275
                },
                plotOptions: {
                    bar: {
                        borderRadiusApplication: "around",
                        columnWidth: "40%"
                    }
                },
                colors: ["#00918E"],
                xaxis: {
                    type: "category",
                    group: {
                        style: {
                            fontSize: "7px",
                            fontWeight: 700
                        }
                    }
                },
                yaxis: {
                    min: 0,
                    max: 500,
                    tickAmount: 5
                }
            }

            const chart = new ApexCharts(chartRef.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])

    //  Leads By Stage
    const LeadsBySatge = useRef(null)

    useEffect(() => {
        if (LeadsBySatge.current) {
            const options = {
                series: [
                    {
                        data: [400, 220, 448]
                    }
                ],
                chart: {
                    type: "bar",
                    height: 150
                },
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#FC0027"],
                xaxis: {
                    categories: ["Conversation", "Follow Up", "Inpipeline"],
                    min: 0,
                    max: 500,
                    tickAmount: 5
                }
            }

            const chart = new ApexCharts(LeadsBySatge.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])
    // Won Deals Chat
    const wonChat = useRef(null)
    useEffect(() => {
        const options = {
            series: [
                {
                    data: [400, 122, 250]
                }
            ],
            chart: {
                type: "bar",
                height: 150
            },
            plotOptions: {
                bar: {
                    horizontal: true
                }
            },
            dataLabels: {
                enabled: false
            },
            colors: ["#5CB85C"],
            xaxis: {
                categories: ["Conversation", "Follow Up", "Inpipeline"],
                min: 0,
                max: 500,
                tickAmount: 5
            }
        }

        if (wonChat.current) {
            const chart = new ApexCharts(wonChat.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])
    // Deals By Year
    const dealsByYear = useRef(null)
    useEffect(() => {
        const options = {
            series: [
                {
                    name: "Deals",
                    data: [10, 20, 30, 15, 22, 40, 30, 20, 30, 18, 30, 60]
                }
            ],
            chart: {
                height: 273,
                type: "area",
                zoom: {
                    enabled: false
                }
            },
            colors: ["#E41F07"],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: "straight"
            },
            title: {
                text: "",
                align: "left"
            },
            xaxis: {
                categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ]
            },
            yaxis: {
                min: 10,
                max: 60,
                tickAmount: 5,
                labels: {
                    formatter: val => {
                        return val / 1 + "K"
                    }
                }
            },
            legend: {
                position: "top",
                horizontalAlign: "left"
            }
        }

        if (dealsByYear.current) {
            const chart = new ApexCharts(dealsByYear.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])

    const initialSettings = {
        endDate: new Date("2020-08-11T12:30:00.000Z"),
        ranges: {
            "Last 30 Days": [
                new Date("2020-07-12T04:57:17.076Z"),
                new Date("2020-08-10T04:57:17.076Z")
            ],
            "Last 7 Days": [
                new Date("2020-08-04T04:57:17.076Z"),
                new Date("2020-08-10T04:57:17.076Z")
            ],
            "Last Month": [
                new Date("2020-06-30T18:30:00.000Z"),
                new Date("2020-07-31T18:29:59.999Z")
            ],
            "This Month": [
                new Date("2020-07-31T18:30:00.000Z"),
                new Date("2020-08-31T18:29:59.999Z")
            ],
            Today: [
                new Date("2020-08-10T04:57:17.076Z"),
                new Date("2020-08-10T04:57:17.076Z")
            ],
            Yesterday: [
                new Date("2020-08-09T04:57:17.076Z"),
                new Date("2020-08-09T04:57:17.076Z")
            ]
        },
        startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
        timePicker: false
    }
    const location = useLocation()
    const [showLoader, setShowLoader] = useState(false)

    useEffect(() => {
        if (location.pathname === "/flexichain/dashboard") {
            setShowLoader(true)
            setTimeout(() => {
                setShowLoader(false)
            }, 2000)
        }
    }, [location.pathname])

    const headerCollapse = useSelector(state => state.headerCollapse)

    // const toggleHeaderCollapse = () => {
    //   dispatch(setHeaderCollapse(!headerCollapse))
    // }

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-header">
                                <div className="row align-items-center ">
                                    <div className="col-md-4">
                                        <h3 className="page-title">Pricing Dashboard</h3>
                                    </div>
                                    <div className="col-md-8 float-end ms-auto">
                                        <div className="d-flex title-head">
                                            <div className="daterange-picker d-flex align-items-center justify-content-center">
                                                {/* <div className="form-sort me-2">
                                                    <i className="ti ti-calendar" />
                                                    <DateRangePicker initialSettings={initialSettings}>
                                                        <input
                                                            className="form-control bookingrange"
                                                            type="text"
                                                        />
                                                    </DateRangePicker>
                                                </div> */}
                                                <div className="head-icons mb-0">
                                                    {/* <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={<Tooltip id="refresh-tooltip">Refresh</Tooltip>}
                                                    >
                                                        <Link to="#">
                                                            <i className="ti ti-refresh-dot" />
                                                        </Link>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={<Tooltip id="collapse-tooltip">Collapse</Tooltip>}
                                                    >
                                                        <Link to="#" id="collapse-header">
                                                            <i className="ti ti-chevrons-up" />
                                                        </Link>
                                                    </OverlayTrigger> */}
                                                    <select className="form-select" name="year" id="yearDropdown" onChange={handleYearChange} value={pricingcurrentYear}>
                                                        {years.map(year => (
                                                            <option key={year} value={year}>{year}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Total Requested Leads
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        {PricingDashboardCounter?.data?.requestedPricingLeadsCount}
                                    </span>
                                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M21.4683 4.83296C21.4683 8.3499 24.3235 11.2009 27.8456 11.2009C28.2334 11.199 28.6202 11.1618 29.0013 11.0897V23.7144C29.0013 29.0257 25.8683 32.168 20.5493 32.168H8.96428C3.63129 32.168 0.498337 29.0257 0.498337 23.7144V12.1464C0.498337 6.83512 3.63129 3.66504 8.96428 3.66504H21.5796C21.5048 4.04984 21.4675 4.44098 21.4683 4.83296ZM18.1543 20.9197L22.6797 15.0801V15.0523C23.0671 14.5317 22.9682 13.7977 22.4569 13.3978C22.2094 13.2067 21.8949 13.124 21.5852 13.1685C21.2756 13.2131 20.9972 13.3811 20.8138 13.6341L16.9986 18.5422L12.6542 15.1218C12.4062 14.9286 12.0906 14.8433 11.7789 14.8851C11.4671 14.927 11.1853 15.0925 10.9972 15.3443L6.31867 21.3786C6.15422 21.5836 6.06569 21.8389 6.06804 22.1016C6.04088 22.6324 6.37607 23.1145 6.88359 23.2748C7.39111 23.435 7.94295 23.2328 8.22629 22.7829L12.139 17.7219L16.4834 21.1283C16.7305 21.3275 17.0481 21.4178 17.3632 21.3785C17.6783 21.3392 17.9639 21.1736 18.1543 20.9197Z"
                                            fill="#000000" />
                                        <ellipse opacity="0.4" cx="28.2095" cy="4.45679" rx="3.95874" ry="3.95874" fill="#646464" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Total In Progress Leads
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        {PricingDashboardCounter?.data?.pricingInProgressCount}
                                    </span>
                                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M21.4683 4.83296C21.4683 8.3499 24.3235 11.2009 27.8456 11.2009C28.2334 11.199 28.6202 11.1618 29.0013 11.0897V23.7144C29.0013 29.0257 25.8683 32.168 20.5493 32.168H8.96428C3.63129 32.168 0.498337 29.0257 0.498337 23.7144V12.1464C0.498337 6.83512 3.63129 3.66504 8.96428 3.66504H21.5796C21.5048 4.04984 21.4675 4.44098 21.4683 4.83296ZM18.1543 20.9197L22.6797 15.0801V15.0523C23.0671 14.5317 22.9682 13.7977 22.4569 13.3978C22.2094 13.2067 21.8949 13.124 21.5852 13.1685C21.2756 13.2131 20.9972 13.3811 20.8138 13.6341L16.9986 18.5422L12.6542 15.1218C12.4062 14.9286 12.0906 14.8433 11.7789 14.8851C11.4671 14.927 11.1853 15.0925 10.9972 15.3443L6.31867 21.3786C6.15422 21.5836 6.06569 21.8389 6.06804 22.1016C6.04088 22.6324 6.37607 23.1145 6.88359 23.2748C7.39111 23.435 7.94295 23.2328 8.22629 22.7829L12.139 17.7219L16.4834 21.1283C16.7305 21.3275 17.0481 21.4178 17.3632 21.3785C17.6783 21.3392 17.9639 21.1736 18.1543 20.9197Z"
                                            fill="#000000" />
                                        <ellipse opacity="0.4" cx="28.2095" cy="4.45679" rx="3.95874" ry="3.95874" fill="#646464" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Total Priced/Sent Leads
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        {PricingDashboardCounter?.data?.sentPricingLeadsCount}
                                    </span>
                                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M21.4683 4.83296C21.4683 8.3499 24.3235 11.2009 27.8456 11.2009C28.2334 11.199 28.6202 11.1618 29.0013 11.0897V23.7144C29.0013 29.0257 25.8683 32.168 20.5493 32.168H8.96428C3.63129 32.168 0.498337 29.0257 0.498337 23.7144V12.1464C0.498337 6.83512 3.63129 3.66504 8.96428 3.66504H21.5796C21.5048 4.04984 21.4675 4.44098 21.4683 4.83296ZM18.1543 20.9197L22.6797 15.0801V15.0523C23.0671 14.5317 22.9682 13.7977 22.4569 13.3978C22.2094 13.2067 21.8949 13.124 21.5852 13.1685C21.2756 13.2131 20.9972 13.3811 20.8138 13.6341L16.9986 18.5422L12.6542 15.1218C12.4062 14.9286 12.0906 14.8433 11.7789 14.8851C11.4671 14.927 11.1853 15.0925 10.9972 15.3443L6.31867 21.3786C6.15422 21.5836 6.06569 21.8389 6.06804 22.1016C6.04088 22.6324 6.37607 23.1145 6.88359 23.2748C7.39111 23.435 7.94295 23.2328 8.22629 22.7829L12.139 17.7219L16.4834 21.1283C16.7305 21.3275 17.0481 21.4178 17.3632 21.3785C17.6783 21.3392 17.9639 21.1736 18.1543 20.9197Z"
                                            fill="#000000" />
                                        <ellipse opacity="0.4" cx="28.2095" cy="4.45679" rx="3.95874" ry="3.95874" fill="#646464" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Total Repricing Leads
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        {PricingDashboardCounter?.data?.repricingPricingLeadsCount}
                                    </span>
                                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M21.4683 4.83296C21.4683 8.3499 24.3235 11.2009 27.8456 11.2009C28.2334 11.199 28.6202 11.1618 29.0013 11.0897V23.7144C29.0013 29.0257 25.8683 32.168 20.5493 32.168H8.96428C3.63129 32.168 0.498337 29.0257 0.498337 23.7144V12.1464C0.498337 6.83512 3.63129 3.66504 8.96428 3.66504H21.5796C21.5048 4.04984 21.4675 4.44098 21.4683 4.83296ZM18.1543 20.9197L22.6797 15.0801V15.0523C23.0671 14.5317 22.9682 13.7977 22.4569 13.3978C22.2094 13.2067 21.8949 13.124 21.5852 13.1685C21.2756 13.2131 20.9972 13.3811 20.8138 13.6341L16.9986 18.5422L12.6542 15.1218C12.4062 14.9286 12.0906 14.8433 11.7789 14.8851C11.4671 14.927 11.1853 15.0925 10.9972 15.3443L6.31867 21.3786C6.15422 21.5836 6.06569 21.8389 6.06804 22.1016C6.04088 22.6324 6.37607 23.1145 6.88359 23.2748C7.39111 23.435 7.94295 23.2328 8.22629 22.7829L12.139 17.7219L16.4834 21.1283C16.7305 21.3275 17.0481 21.4178 17.3632 21.3785C17.6783 21.3392 17.9639 21.1736 18.1543 20.9197Z"
                                            fill="#000000" />
                                        <ellipse opacity="0.4" cx="28.2095" cy="4.45679" rx="3.95874" ry="3.95874" fill="#646464" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            All Leads
                                        </h4>
                                        <div className="dropdown">
                                            <select className="form-select" name="dropdown" id="graphDropdown" onChange={handleGraphDropdownChange} value={pricingdropdownValue}>
                                                {DashboardGraphDropdownData?.map(option => (
                                                    <option key={option} value={option}>{option}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* <LineChart
                                    xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
                                    series={[
                                        {
                                            data: [2, 5.5, 2, 8.5, 1.5, 5],
                                            area: true,
                                        },
                                    ]}
                                    width="100%"
                                    height={300}
                                /> */}
                                {/* <ResponsiveContainer width="100%" height={300}>
                                    <LineChart
                                        data={data}
                                        margin={{
                                            top: 20, right: 30, left: 20, bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis style={{ fontSize: '12px' }} dataKey="name" />
                                        <YAxis style={{ fontSize: '12px' }} />
                                        <Tooltip />
                                        <Legend />
                                        <Line type="monotone" dataKey="Converted" stroke="#008500"  activeDot={{ r: 8 }} />
                                        <Line type="monotone" dataKey="Picked" stroke="#efff00" />
                                        <Line type="monotone" dataKey="NotConverted" stroke="#ff0000" />
                                    </LineChart>
                                </ResponsiveContainer> */}
                                <ResponsiveContainer width="100%" height={250}>
                                    <AreaChart width="100%" height={250} data={selectedGraphData}
                                        margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                                        <defs>
                                            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                                            </linearGradient>
                                            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#f2ff33c9" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#f2ff33c9" stopOpacity={0} />
                                            </linearGradient>
                                            <linearGradient id="colorNv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#f62f2cbf" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#f62f2cbf" stopOpacity={0} />
                                            </linearGradient>
                                        </defs>
                                        <XAxis dataKey="name" style={{ fontSize: '10px' }} />
                                        <YAxis style={{ fontSize: '10px' }} />
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <Tooltip />
                                        <Legend content={renderLegend} />
                                        <Area type="monotone" dataKey="Requested" stroke="#82ca9d" fillOpacity={1} fill="url(#colorUv)" />
                                        <Area type="monotone" dataKey="InProcess" stroke="#f2ff33c9" fillOpacity={1} fill="url(#colorPv)" />
                                        <Area type="monotone" dataKey="Sent" stroke="#f62f2cbf" fillOpacity={1} fill="url(#colorNv)" />
                                    </AreaChart>
                                </ResponsiveContainer>

                                {/* <ResponsiveContainer width="100%" height={300}>
                                    <LineChart
                                        data={data}
                                        margin={{
                                            top: 20, right: 30, left: 20, bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis style={{ fontSize: '12px' }} dataKey="name" />
                                        <YAxis style={{ fontSize: '12px' }} />
                                        <Tooltip />
                                        <Legend />
                                        <Line type="monotone" dataKey="Converted" stroke="#008500" activeDot={{ r: 8 }} />
                                        <Line type="monotone" dataKey="Picked" stroke="#efff00" />
                                        <Line type="monotone" dataKey="NotConverted" stroke="#ff0000" />
                                    </LineChart>
                                </ResponsiveContainer> */}
                            </div>

                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Recently Requested Leads
                                        </h4>
                                        {/* <div className="dropdown">
                                            <Link
                                                className="dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                to="#"
                                            >
                                                <i className="ti ti-calendar-check me-2" />
                                                Last 30 days
                                            </Link>
                                            <div className="dropdown-menu dropdown-menu-end">
                                                <Link to="#" className="dropdown-item">
                                                    Last 15 days
                                                </Link>
                                                <Link to="#" className="dropdown-item">
                                                    Last 30 days
                                                </Link>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive custom-table">
                                        <table className="table dataTable" >
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>Request No.</th>
                                                    <th>Date</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Origin</th>
                                                    <th>Destination</th>
                                                    <th>Shipment Mode</th>
                                                    {/* <th>Status</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {PricingDashboardCounter?.data?.recentLeads?.length > 0 ?
                                                    <>
                                                        {PricingDashboardCounter?.data?.recentLeads?.map((values) => (


                                                            <tr className="odd">
                                                                <td>{values?.request_no ? values?.request_no : 'N/A'}</td>
                                                                <td>{values?.createdAt ? new Date(values?.createdAt).toLocaleDateString() : 'N/A'}</td>
                                                                <td>{values?.full_name ? values.full_name : 'N/A'}</td>
                                                                <td>{values?.email ? values?.email : 'N/A'}</td>
                                                                <td>{values?.phone ? values?.phone : 'N/A'}</td>
                                                                <td>{values?.origin_address ? values?.origin_address : 'N/A'}</td>
                                                                <td>{values?.destination_address ? values?.destination_address : 'N/A'}</td>
                                                                <td>{values?.shipment_mode ? values?.shipment_mode : 'N/A'}</td>
                                                                {/* <td>
            <span className="badge badge-pill  bg-danger">
                Lost
            </span>
        </td> */}
                                                            </tr>
                                                        ))}
                                                    </>
                                                    :
                                                    <p>No Data</p>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Deals By Stage
                                        </h4>
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <div className="dropdown me-2">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Sales Pipeline
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Marketing Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Sales Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Email
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Chats
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Operational
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="dropdown">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Last 30 Days
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Last 30 Days
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 15 Days
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 7 Days
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div ref={chartRef} />
                                </div>
                            </div>
                        </div> */}
                    </div>
                    {/* <div className="row">
                        <div className="col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Leads By Stage
                                        </h4>
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <div className="dropdown me-2">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Marketing Pipeline
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Marketing Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Sales Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Email
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Chats
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Operational
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="dropdown">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Last 3 months
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Last 3 months
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 6 months
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 12 months
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div ref={LeadsBySatge} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Won Deals Stage
                                        </h4>
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <div className="dropdown me-2">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Marketing Pipeline
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Marketing Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Sales Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Email
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Chats
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Operational
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="dropdown">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Last 3 months
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Last 3 months
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 6 months
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 12 months
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div ref={wonChat} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 d-flex">
                            <div className="card w-100">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Deals by Year
                                        </h4>
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <div className="dropdown me-2">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Sales Pipeline
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Marketing Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Sales Pipeline
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="dropdown">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Last 3 months
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Last 3 months
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 6 months
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 12 months
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div ref={dealsByYear} />
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default PricingDashboard
